import RouteTemplate from "ember-route-template";

export default RouteTemplate(
  <template>
    <section class="proxyviews-methodology-page">
      <div class="pd-hero">
        <span class="pd-hero__eyebrow">ProxyViews Integrity</span>
        <h1 class="pd-hero__title">
          <span>{{@model.title}}</span>
        </h1>
        <p class="pd-hero__subtitle">
          {{#if @model.custom_intro}}
            {{@model.custom_intro}}
          {{else}}
            Learn how we benchmark, verify, and rate every proxy provider. We stand for transparency and objective, data-driven testing — without the affiliate noise.
          {{/if}}
        </p>
      </div>

      <div class="pd-methodology-container">
        {{#if @model.video_url}}
          <div class="pd-methodology-video">
            <div class="pd-methodology-video__header">
              <div>
                <span class="pd-methodology-video__badge">
                  <span class="pd-video-live-dot"></span> Live Testing Record
                </span>
                <h2 class="pd-methodology-video__title">{{@model.video_title}}</h2>
                <p class="pd-methodology-video__desc">{{@model.video_description}}</p>
              </div>
              <a
                href="{{@model.video_url}}"
                target="_blank"
                rel="noopener noreferrer"
                class="pd-methodology-video__link-btn"
              >
                Open Video ↗
              </a>
            </div>

            {{#if @model.is_embed}}
              <div class="pd-methodology-video__wrapper">
                <iframe
                  class="pd-methodology-video__iframe"
                  src="{{@model.video_embed_url}}"
                  title="{{@model.video_title}}"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen
                ></iframe>
              </div>
            {{else if @model.is_direct}}
              <div class="pd-methodology-video__wrapper">
                <video
                  class="pd-methodology-video__player"
                  controls
                  preload="metadata"
                  src="{{@model.video_url}}"
                ></video>
              </div>
            {{else}}
              <div class="pd-methodology-video__fallback">
                <p>Watch our unedited live benchmark testing recording:</p>
                <a
                  href="{{@model.video_url}}"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="pd-methodology-video__link-btn"
                >
                  ▶ Watch Live Testing Recording
                </a>
              </div>
            {{/if}}

            <div class="pd-methodology-video__meta-strip">
              <span class="pd-methodology-video__meta-item">🎥 Uncut Session</span>
              <span class="pd-methodology-video__meta-item">🌍 Multi-Region Latency Tested</span>
              <span class="pd-methodology-video__meta-item">🛡️ 100% Objective & Independent</span>
            </div>
          </div>
        {{/if}}

        <div class="pd-methodology-grid">
          {{#each @model.sections as |section|}}
            <div class="pd-methodology-card">
              <h2 class="pd-methodology-card__heading">{{section.heading}}</h2>
              <p class="pd-methodology-card__body">{{section.body}}</p>
            </div>
          {{/each}}
        </div>
      </div>
    </section>
  </template>
);
